// https://stackoverflow.com/questions/18017869/build-tree-array-from-flat-array-in-javascript
export function convertFlatMenuToStructuredTree(list) {
    let map = {},
        node,
        roots = [],
        i

    for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i
        list[i].pages = []
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i]
        if (node.parent !== null) {
            if (map[node.parent.id] !== undefined) {
                list[map[node.parent.id]].pages.push(node)
            }
        } else {
            roots.push(node)
        }
    }
    return roots
}

export function filterMenuByUserStatus(menuItems, user) {
    const userStatusFilter = user?.isLoggedIn ? "loggedOutOnly" : "loggedInOnly"

    const filterItem = menuItem => {
        if (menuItem.userStatus === "crfStaffOnly" && !user?.isCrfStaff) return []
        if (menuItem.userStatus === userStatusFilter) return []

        menuItem.pages = menuItem.pages.flatMap(filterItem)

        return menuItem
    }

    return menuItems.flatMap(filterItem)
}

export function scrollTo(element, adjustment = 0) {
    const menuBottomY = document.getElementsByClassName("menubar")[0]?.getBoundingClientRect().bottom
        ? document.getElementsByClassName("menubar")[0].getBoundingClientRect().bottom
        : 0
    const y = element.getBoundingClientRect().top + window.scrollY - menuBottomY + adjustment
    window.scrollTo({ top: y, behavior: "smooth" })
}

export function getModerators(event, rolesCSV, rolesAdditionalCSV) {
    let _customModerators = []
    let _standardModerators = []

    if (rolesCSV || rolesAdditionalCSV) {
        const combinedModeratorRolesCsv = [rolesCSV, rolesAdditionalCSV].join(",")
        const rolesArray = combinedModeratorRolesCsv?.split(",").map(role => role.trim())
        _customModerators = event.moderators.reduce((all, group) => {
            if (rolesArray.includes(group.role.name)) {
                return [...all, ...group.users]
            }
            return all
        }, [])
    }

    // if standard roles were not overridden, then add them
    if (!rolesCSV) {
        // get all faculty in a role slug that includes 'moderator'
        _standardModerators = event.moderators.reduce((all, group) => {
            if (group.role?.slug?.includes("moderator")) {
                return [...all, ...group.users]
            }
            return all
        }, [])
    }

    // merge both arrays and remove duplicates
    const result = [...new Set([..._standardModerators, ..._customModerators])]

    // If no moderators found directly, fall back to children
    if (result.length === 0 && event.children?.length > 0) {
        return event.children.flatMap(child => getModerators(child, rolesCSV, rolesAdditionalCSV))
    }

    return result
}

export function getDiscussants(event, rolesCSV, rolesAdditionalCSV) {
    let _customDiscussants = []
    let _standardDiscussants = []

    if (rolesCSV || rolesAdditionalCSV) {
        const combinedModeratorRolesCsv = [rolesCSV, rolesAdditionalCSV].join(",")
        const rolesArray = combinedModeratorRolesCsv?.split(",").map(role => role.trim())
        _customDiscussants = event.moderators.reduce((all, group) => {
            if (rolesArray.includes(group.role.name)) {
                return [...all, ...group.users]
            }
            return all
        }, [])
    }

    // if standard roles were not overridden, then add them
    if (!rolesCSV) {
        // default discussant logic:
        // get all faculty in a role that contains 'discussant' AND (either not 'monitor' or does include 'chat-monitor'
        // cap array length at 6
        _standardDiscussants = event.moderators
            .reduce((all, group) => {
                if (
                    group.role?.slug?.includes("discussant") &&
                    (!group.role?.slug?.includes("monitor") || group.role?.slug?.includes("chat-monitor"))
                ) {
                    return [...all, ...group.users]
                }
                return all
            }, [])
            .slice(0, 6)
    }

    return [...new Set([..._standardDiscussants, ..._customDiscussants])]
}
